var _desc, _defs, _rect, _rect2, _rect3, _rect4, _g, _g2, _text, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealershipdb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dbTitle"
  }, "Car Dealership Database") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dbTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "dbDesc"
  }, "A blueprint drawing of a car above an entity-relationship schema for a dealership database.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "dbGrid",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0 L0 0 L0 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1,
    opacity: 0.07
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dbGridMajor",
    width: 120,
    height: 120,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 0 L0 0 L0 120",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    opacity: 0.13
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#153a7e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#dbGrid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#dbGridMajor)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 772,
    height: 422,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    fill: "none",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266 152 C284 126 318 108 366 104 L448 104 C492 106 520 122 538 148 L562 154 C574 157 580 164 580 173 L580 182 L220 182 L220 172 C220 163 227 156 238 154 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 108 L358 148 L448 148 L442 108",
    strokeWidth: 2,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 108,
    x2: 400,
    y2: 148,
    strokeWidth: 1.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 182,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 182,
    r: 11,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 182,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 182,
    r: 11,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232,
    y1: 168,
    x2: 248,
    y2: 168,
    strokeWidth: 1.5,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 552,
    y1: 166,
    x2: 568,
    y2: 166,
    strokeWidth: 1.5,
    opacity: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 226,
    x2: 504,
    y2: 226,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 216,
    x2: 300,
    y2: 236,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504,
    y1: 216,
    x2: 504,
    y2: 236,
    strokeWidth: 1.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 402,
    y: 221,
    textAnchor: "middle",
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 13,
    fill: "#ffffff",
    opacity: 0.85
  }, "wheelbase 2.7m")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 1.8,
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: 298,
    x2: 330,
    y2: 322
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637,
    y1: 298,
    x2: 470,
    y2: 322
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: 322,
    x2: 163,
    y2: 298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 637,
    y1: 322,
    x2: 637,
    y2: 298
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 322 L318 314 M330 322 L318 322 M330 322 L318 330",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 322 L482 314 M470 322 L482 322 M470 322 L482 330",
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 15,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 272,
    width: 150,
    height: 40,
    rx: 4,
    fill: "#153a7e",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 163,
    y: 297,
    fill: "#ffffff"
  }, "CUSTOMERS"), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 302,
    width: 140,
    height: 40,
    rx: 4,
    fill: "#153a7e",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 327,
    fill: "#ffffff"
  }, "SALES"), /*#__PURE__*/React.createElement("rect", {
    x: 562,
    y: 272,
    width: 150,
    height: 40,
    rx: 4,
    fill: "#153a7e",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 637,
    y: 297,
    fill: "#ffffff"
  }, "VEHICLES"), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 356,
    width: 150,
    height: 40,
    rx: 4,
    fill: "#153a7e",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 313,
    y: 381,
    fill: "#ffffff"
  }, "SERVICE"), /*#__PURE__*/React.createElement("rect", {
    x: 422,
    y: 356,
    width: 176,
    height: 40,
    rx: 4,
    fill: "#153a7e",
    stroke: "#ffffff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 381,
    fill: "#ffffff"
  }, "APPOINTMENTS"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 1.8,
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("line", {
    x1: 352,
    y1: 342,
    x2: 330,
    y2: 356
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448,
    y1: 342,
    x2: 470,
    y2: 356
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 52,
    width: 212,
    height: 66,
    fill: "#153a7e",
    stroke: "#ffffff",
    strokeWidth: 2,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560,
    y1: 85,
    x2: 772,
    y2: 85,
    stroke: "#ffffff",
    strokeWidth: 1.5,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 74,
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 15,
    fontWeight: 700,
    fill: "#ffffff",
    letterSpacing: 1.5
  }, "DEALERSHIP DB"), /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 106,
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 12,
    fill: "#ffffff",
    opacity: 0.8
  }, "MySQL \xB7 CS 4347 \xB7 SCALE 1:1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealershipdb);
export default __webpack_public_path__ + "static/media/dealershipdb.792d35e849c35e2ca4d3f0d37435f19e.svg";
export { ForwardRef as ReactComponent };